export enum AkcijeNadSvojstvom {
    IZMENA = "izmena",
    BRISANJE = "brisanje",
    PREGLED = "pregled",
    DEAKTIVIRANJE = "deaktiviranje",
    REAKTIVIRANJE = "reaktiviranje",
    PREGLED_EVIDENCIJA = "pregledEvidencija",
    DUPLIKACIJA = "duplikacija",
    PODSTABLO = "podstablo",
    POMERANJE_GORE = "pomeranjeGore",
    POMERANJE_DOLE = "pomeranjeDole",
}